module.exports = __webpack_public_path__ + "static/media/start-tour.4f501078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/start-tour.svg
// module id = 1367
// module chunks = 0